// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3Q9wV","title":"AfterFrontImage_title__ah9j3"};